import React from 'react';

import Checkbox from '/component/base/Checkbox';
import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';

interface DetailListItemProps {
  data: Record<string, any>;
  getTitle: (data: Record<string, any>) => string;
  isComplete: boolean;
}

const DetailListItem = ({
  data = {},
  getTitle = () => '',
  isComplete = false,
}: DetailListItemProps) => {
  return (
    <ListItem
      prefix={<Checkbox checked={isComplete} readonly />}
      label={
        <Text allowFontScaling maxFontSizeMultiplier={2}>
          {getTitle(data)}
        </Text>
      }
      readonly
    />
  );
};

export default DetailListItem;
